/*
 * Filtro che sostituisce gli a capo con i BR
*/
angular.module('app').filter('newLineToBrFilter', () => {
    return (value: string) => {
        if (!value) return '';
        return value.replace(/(?:\r\n|\r|\n)/gm, '<br>');
    };
});